/**
 * Canonical Job Pricing Selectors — Customer-Facing Value
 * ───────────────────────────────────────────────────────
 * Customer/revenue-facing surfaces MUST resolve job display value through
 * `getJobDisplayValue()` and customer-aggregate value through
 * `getCustomerLifetimeValue()`. Both read `Job.financials.contractValue`
 * — the canonical, change-order-aware contract amount.
 *
 * `Job.payoutAmount` represents the SUBCONTRACTOR INSTALL PAYOUT and must
 * never be displayed as customer revenue, sales value, or contract value.
 * It is reserved for contractor-pay / dispatch / installer-payout contexts.
 *
 * See mem://finance/canonical-pricing.
 */
import type { Job } from "./types";

/** Canonical customer-facing display value for a single job. */
export function getJobDisplayValue(job: Job): number {
  return job.financials?.contractValue ?? 0;
}

/** Canonical customer lifetime value across all of a customer's jobs. */
export function getCustomerLifetimeValue(jobs: Job[]): number {
  return jobs.reduce((sum, j) => sum + getJobDisplayValue(j), 0);
}
